import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ADDTOFAV, OPERERROR, REMOVEVEF } from 'src/app/tabms/tab-consts';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { UserFavouritePageService } from 'src/app/tabms/services/global/user-favourite-page.service';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { TabSystemMenuService } from 'src/app/tabms/services/menu/tab-system-menu.service';

@Component({
  selector: 'app-footer-entry-page-tools',
  templateUrl: './footer-entry-page-tools.component.html',
  styleUrl: './footer-entry-page-tools.component.scss'
})
export class FooterEntryPageToolsComponent {
  //#region inputs
  @Input() set service(_service) {
    if (!_service) return;
    this.serviceInstance = _service;
  }
  //#endregion

  userId;
  systemMenuId;
  userFavouritePageId;
  isFavourite = false;
  favColor = '#000000';
  serviceInstance;
  menuKey: string;
  pageParameter: string;
  private destroy$: Subject<void> = new Subject<void>();

  //#endregion

  //#region constructor
  constructor(
    private baseService: BaseService,
    private activatedRoute: ActivatedRoute,
    private userFavouritePageService: UserFavouritePageService,
    private sessionService: SessionWrapperService,
    private tabSystemMenuService: TabSystemMenuService
  ) { }
  //#endregion

  //#region life hooks
  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.systemMenuId = params['id'];
      this.getMenuKey(this.systemMenuId);
    });

    this.userFavouritePageService.getUserFavouritePages()?.pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        let userFavPages = res.result;
        if (userFavPages) {
          this.userFavouritePageId = userFavPages.find((x) => x.tabsystemmenuid == this.systemMenuId)?.id;
          this.isFavourite = this.userFavouritePageId ? true : false;
          this.favColor = this.isFavourite ? '#ddcd0a' : '#000000';
        }
      },
      (err) => {
        console.log('userFavouritePageService.getbyParam err', err);
        this.isFavourite = false;
      }
    );

  }
  //#endregion

  //#region favourite
  favouriteClick() {
    if (this.isFavourite) {
      this.favColor = '#000000';
      this.removeFavourite();
    } else {
      this.favColor = '#ddcd0a';
      this.addFavourite();
    }
    this.isFavourite = !this.isFavourite;
  }

  addFavourite() {
    let claims = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
    if (claims) {
      this.userId = claims['sub'];
    }
    let userFavourite = {
      identityuserid: this.userId,
      tabsystemmenuid: this.systemMenuId,
      menukey: this.menuKey,
      pageparameter: this.pageParameter
    };
    this.userFavouritePageService.create(userFavourite)?.pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.userFavouritePageId = res?.result?.id;
        this.baseService.showSuccessMessage(ADDTOFAV);
        this.baseService.addRemoveFavourite.next(1);
      },
      (err) => {
        console.log('userFavouritePage create err', err);
        this.baseService.showErrorMessage(OPERERROR);
      });
  }

  removeFavourite() {
    this.userFavouritePageService.delete(this.userFavouritePageId)?.pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.baseService.showSuccessMessage(REMOVEVEF);
        this.baseService.addRemoveFavourite.next(2);
      },
      error: (err) => {
        console.log('userFavouritePageService.delete err', err);
        this.baseService.showErrorMessage(OPERERROR);
      }
    });
  }
  //#endregion

  getMenuKey(id) {
    this.tabSystemMenuService.get(id).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.menuKey = res.result.menukey;
        this.pageParameter = res.result.pageparameters;
        // console.log('this.menuKey', this.menuKey);
        this.sessionService.setMenuKeyAndPageParameter(this.menuKey, this.pageParameter);
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
